module.exports = __webpack_public_path__ + "static/stripe-integration-graphic-mobile-f059ab7499ba93916c776dfd677238b9.svg";